import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router } from '@angular/router';
import { UserAccessService } from '../services/user-access.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'environments/environment';
// import { LookupEnvironmentService } from './../../shared/services/lookup-environment.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
	private cookie: CookieService;

	constructor(
		private router: Router,
		// private env: LookupEnvironmentService,
		cookieService: CookieService,
		private session: SessionService,
		private userAccessSvc: UserAccessService
	) {
		this.cookie = cookieService;
	}

	canActivate() {
		if (
			this.cookie.get('IsAuthorized') === 'agent' ||
			environment.DISABLE_AUTH
		) {
			return true;
		}

		// // logout redirect to the shared login application
		// this.session.logout(true).subscribe();
        //this.router.navigate(['logout/true']);
        this.session.logout(true);
		return false;
	}

	canLoad(route: Route) {
		const result = true;
		this.userAccessSvc.getUserAccess();
		return result;
	}
}
